
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"800","width":"800","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 254.3 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M140.4 18.6c-12.2 0-22.1 9.9-22.1 22.1s9.9 22.1 22.1 22.1 22.1-9.9 22.1-22.1-9.9-22.1-22.1-22.1zm85 37.7l-69.2 42.3-8.9 107.4c-.5 7.1-6.5 12.6-13.6 12.6h-.9l-43-2.7c-2.7-.2-5.2-1.1-7.3-2.7l23.5-23.6 15.1.9 1.5-21.4h-7.4l-38.4 38.6c-2.7 2.6-6.1 4-9.6 4-3.4 0-6.8-1.3-9.5-3.8l-30.4-29.4c-5.4-5.2-5.5-13.8-.3-19.2 5.2-5.4 13.8-5.5 19.2-.3l20.9 20 25.7-25.8 6.7-70L53 20.8c-3.9-5.2-2.8-12.6 2.4-16.4C60.6.5 68 1.6 71.8 6.8L114.5 64l36.9 10 61.7-37.7c5.5-3.4 12.8-1.6 16.2 3.9 3.4 5.5 1.6 12.7-3.9 16.1zM92.2 226.4h7.9v19.7h-7.9v-19.7zm-15.7 0h7.9V254h-7.9v-27.6zm-15.8 0h7.9v19.7h-7.9v-19.7z"}})])
          )
        }
      }
    